import { render, staticRenderFns } from "./Orange.vue?vue&type=template&id=7ed66658&scoped=true&"
import script from "./Orange.vue?vue&type=script&lang=ts&"
export * from "./Orange.vue?vue&type=script&lang=ts&"
import style0 from "./Orange.vue?vue&type=style&index=0&id=7ed66658&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ed66658",
  null
  
)

export default component.exports